"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const OverlayTrigger_1 = __importDefault(require("react-bootstrap/esm/OverlayTrigger"));
const ConditionalTooltipWrapper = ({ enableTooltip, children, tooltipOptions, }) => enableTooltip ? (react_1.default.createElement(OverlayTrigger_1.default, { placement: (tooltipOptions === null || tooltipOptions === void 0 ? void 0 : tooltipOptions.place) || "top", overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { style: {
            maxWidth: "400px",
        } }, tooltipOptions.content || "No Tooltip Content") }, children)) : children;
exports.default = ConditionalTooltipWrapper;
